export default __webpack_public_path__ + "static/media/invoices-feature-1.4599f84e.png";